/* eslint-disable react-hooks/exhaustive-deps */

import { useHistory } from 'react-router';
import { getBookingDetailsPageLink } from 'lib/links';
import { FLAG_CHANGE_DATE } from 'config';
import { useEffect } from 'react';

export const useCanAmendDatesGuard = (bookingId: string, isDateAmendableInApp: boolean) => {
  const { replace } = useHistory();

  useEffect(() => {
    if (!FLAG_CHANGE_DATE || !isDateAmendableInApp) {
      replace(getBookingDetailsPageLink(bookingId));
    }
  }, []);
};
